export default {
  IDLE: 'idle',
  SLIDESHOW: 'slideshow',
};
